// empty



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/modules/es.math.to-string-tag.js
// module id = 422
// module chunks = 0 1